import React from 'react';
import { useSelector } from 'react-redux';
import SpotListItemPlaceholder from './spot-card-placeholder';
import { Box } from '@spothero/ui';
export const SpotListSkeleton = ({ count = 7 }) => {
    const isSearchPending = useSelector((state) => state.search.isPending);
    const showNoSpotsFound = useSelector((state) => state.search.data.showNoSpotsFound);
    // empty spot place holders are shown while search api request happens first time on page load.
    // place holders are UI indicator (similar to spinners/progress bars) that search is in progress.
    const showPlaceholders = isSearchPending && !showNoSpotsFound;
    const Skeleton = new Array(count).fill(0);
    return showPlaceholders ? (<Box position="sticky" overflow="hidden" height="100vh" // cover up whole box all the time
     top="0" zIndex="100" backgroundColor="gray.50">
            {Skeleton.map((_, index) => (<SpotListItemPlaceholder key={`spot-list-item-placeholder-${index}`}/>))}
        </Box>) : null;
};
